import axios from 'axios';
import effectiveSrvAxios from '../Backend';
// import { parseString } from 'xml2js'//4.23.0
import { XMLParser } from 'fast-xml-parser';
import { formatDateToSQLServer } from '../../util/functions'
const key = 'bamba'
// const parseXmlToObj = (xml) => {
//     return new Promise((resolve, reject) => {
//         parseString(xml, function (err, result) {
//             if (result) {
//                 resolve(result)
//             }
//             else if (err) {
//                 reject(err)
//             }
//         });

//     })
// }



const parseXmlToObj = (xml) => {
    const parser = new XMLParser();
    try {
        const result = parser.parse(xml);
        return Promise.resolve(result);
    } catch (err) {
        return Promise.reject(err);
    }
};


export const getClubCallBack = async (url = "", device) => {
    let obj
    const reqUrl = url.replace("[key]", key).replace("[device]", device)
    const res = await axios.get(reqUrl)
    const resDateXml = res.data

    const resDataObj = await parseXmlToObj(resDateXml)
    const callBackRes = resDataObj?.NewDataSet?.Table?.[0]

    if (callBackRes) {
        obj = {
            externalId: callBackRes.id[0],
            startTime: callBackRes.callTime[0],
            projectDesc: callBackRes.remarks[0] !== 'null' && callBackRes.remarks[0] ? callBackRes.remarks[0] : 'Club Hotel',
            telephone: callBackRes.telephone[0]
        }
    }

    return obj
}

export const deleteClubCallBack = async (url, callId) => {
    const reqUrl = url.replace("[key]", key).replace("[callId]", callId)
    const res = await axios.get(reqUrl)
    const resDateXml = res.data
    // console.log(resDateXml)
    return resDateXml // 1 = success,0=fail
}

export const rejectClubCallBack = async (url, callId, rejectTime, reason, note, priority) => {
    const sqlFormatRejectDateTime = formatDateToSQLServer(rejectTime)
    let reqUrl = url.replace("[key]", key).replace("[callId]", callId).replace("[rejectTime]", sqlFormatRejectDateTime)
    if (reason) {
        reqUrl += `&reason=${reason}`
    }
    if (note) {
        reqUrl += `&note=${note}`
    }
    if (priority) {
        reqUrl += `&priority=${priority}`
    }
    const res = await axios.get(reqUrl)
    const resDateXml = res.data
    // console.log(resDateXml)
    return resDateXml // 1 = success,0=fail
}

export const finishClubCallBack = async (url, callId, reason, note) => {
    let reqUrl = url.replace("[key]", key).replace("[callId]", callId)
    if (reason) {
        reqUrl += `&reason=${reason}`
    }
    if (note) {
        reqUrl += `&note=${note}`
    }
    const res = await axios.get(reqUrl)
    const resDateXml = res.data
    // console.log(resDateXml)
    return resDateXml // 1 = success,0=fail
}

export const getCallBack = async () => {
    try{
    const res = await effectiveSrvAxios.get('/diallist/callback')
    const resData=res.data.data?.dialListItem
    return resData
}catch(e){
    if(e.response?.data){
        console.log(`getCallBack :: Error=${e.response.data.message}`)
    }
    else{
        console.log(`getCallBack :: Error=${e}`)
    }
}
}